<template>
  <div
    v-if="isDisconnected"
    class="platform-disconnect-block-overlay"
    data-testid="platform-disconnect-block-overlay"
    aria-hidden="true"
    @mousedown.prevent
    @click.prevent
    @contextmenu.prevent
    @wheel.prevent
  />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { watch } from 'vue'
import { usePlatformConnectionStore } from '@/stores/platformConnection'

const { isDisconnected } = storeToRefs(usePlatformConnectionStore())

watch(isDisconnected, (disconnected) => {
  if (!disconnected) return
  const active = document.activeElement
  if (active instanceof HTMLElement && typeof active.blur === 'function') {
    active.blur()
  }
})
</script>

<style scoped lang="scss">
.platform-disconnect-block-overlay {
  position: absolute;
  inset: 0;
  z-index: 1100;
  background: rgba(255, 255, 255, 0.01);
  cursor: not-allowed;
  pointer-events: auto;
}
</style>
